export type phase = "development" | "alpha" | "production"

export function getPhase(): phase  {
    return process.env.NEXT_PUBLIC_TEST as phase
}

export function isProduction():boolean {
    return getPhase() === "production"
}